import { render, staticRenderFns } from "./TableauFolderForm.vue?vue&type=template&id=5c83f828&scoped=true&"
import script from "./TableauFolderForm.vue?vue&type=script&lang=js&"
export * from "./TableauFolderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c83f828",
  null
  
)

export default component.exports